module.exports = __webpack_public_path__ + "img/segurify_SURA_1.bd44c666.gif";